import React, { useState, useEffect } from 'react';
import { Card, Typography, Form, Input, InputNumber, Button, message, Spin, Space } from 'antd';
import { SaveOutlined } from '@ant-design/icons';
import { getConfig, updateConfig } from '../../services/adminService';

const { Title, Text } = Typography;

const configLabels = {
  planning_window_days: { label: 'Fenêtre de planification (jours)', type: 'number' },
  max_rdv: { label: 'Max RDV par équipe par jour', type: 'number' },
  distance_warning_km: { label: 'Seuil warning distance (km)', type: 'number' },
  slot_start: { label: 'Heure début créneaux', type: 'number' },
  slot_end: { label: 'Heure fin créneaux', type: 'number' },
  duration_small: { label: 'Durée RDV petite surface (h)', type: 'number' },
  duration_large: { label: 'Durée RDV grande surface (h)', type: 'number' },
  surface_threshold: { label: 'Seuil surface petit/grand (m²)', type: 'number' },
  slot_hours: { label: 'Plages horaires RDV (ex: 9,12,15,18)', type: 'text' },
};

const ConfigPage = () => {
  const [config, setConfig] = useState([]);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [form] = Form.useForm();

  const fetchConfig = async () => {
    setLoading(true);
    try {
      const data = await getConfig();
      setConfig(data.config || []);
      const values = {};
      (data.config || []).forEach(c => {
        values[c.cle] = c.valeur;
      });
      form.setFieldsValue(values);
    } catch (err) {
      console.error('Error:', err);
    } finally {
      setLoading(false);
    }
  };

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => { fetchConfig(); }, []);

  const handleSave = async () => {
    setSaving(true);
    try {
      const values = await form.validateFields();
      const configs = {};
      Object.entries(values).forEach(([key, val]) => {
        configs[key] = String(val);
      });
      await updateConfig(configs);
      message.success('Configuration enregistrée');
      fetchConfig();
    } catch (err) {
      message.error('Erreur lors de la sauvegarde');
    } finally {
      setSaving(false);
    }
  };

  if (loading) return <Spin size="large" style={{ display: 'block', margin: '80px auto' }} />;

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 16 }}>
        <Title level={4} style={{ margin: 0 }}>Configuration</Title>
        <Button
          type="primary"
          icon={<SaveOutlined />}
          onClick={handleSave}
          loading={saving}
          style={{ background: '#059669', borderColor: '#059669' }}
        >
          Enregistrer
        </Button>
      </div>

      <Card>
        <Form form={form} layout="vertical">
          {config.map(c => {
            const meta = configLabels[c.cle] || { label: c.cle, type: 'text' };
            return (
              <Form.Item
                key={c.cle}
                name={c.cle}
                label={<Space><Text strong>{meta.label}</Text><Text type="secondary" style={{ fontSize: 12 }}>({c.cle})</Text></Space>}
                extra={c.description}
              >
                {meta.type === 'number' ? (
                  <InputNumber style={{ width: 200 }} min={0} />
                ) : (
                  <Input style={{ width: 300 }} />
                )}
              </Form.Item>
            );
          })}
        </Form>
      </Card>
    </div>
  );
};

export default ConfigPage;
